import * as React from 'react';

import Gear16 from './Gear16';

export const gear16 = () => <Gear16 />;

export default {
    title: 'Icon|Fill|Gear16',
    component: Gear16,
    parameters: {
        notes: "`import Gear16 from 'box-ui-elements/es/icon/fill/Gear16';`",
    },
};
